<template>
  <main>
    <!-- Navbar -->
    <nav
      class="no-printable sticky top-0 left-0 w-full z-40 bg-white flex md:flex-row md:flex-nowrap md:justify-start items-center p-2 md:shadow-lg"
    >
      <div
        class="w-full mx-auto items-center flex justify-between flex-nowrap flex-wrap md:px-16 py-1 px-2 md:px-4"
      >
        <!-- Brand -->

        <div
          v-if="companyData && companyData.registrationType === 'COMPANY'"
          @click="
            $router.push({
              name: 'BusinessProfile',
            })
          "
          class="cursor-pointer overflow-hidden border border-indigo-100 w-14 h-14 rounded-full text-white flex items-center justify-center font-bold text-2xl"
        >
          <span
            v-if="companyData && companyData.registrationType === 'COMPANY'"
            class="w-full h-full"
          >
            <img
              v-if="companyData && companyData.company.logo"
              :src="companyData && companyData.company.logo"
              alt=""
              class="object-cover w-full h-full rounded-full"
            />

            <img
              v-else
              :src="dummyLogo"
              class="object-cover object-center w-full h-full"
              alt=""
            />
          </span>
          <span v-else class="w-full h-full">
            <img
              v-if="
                companyAdmin &&
                companyAdmin.companyAdmin &&
                companyAdmin.companyAdmin.pfp
              "
              :src="
                companyAdmin &&
                companyAdmin.companyAdmin &&
                companyAdmin.companyAdmin.pfp
              "
              alt=""
              class="object-cover w-full h-full rounded-full"
            />

            <img
              v-else
              :src="dummyLogo"
              class="object-cover object-center w-full h-full"
              alt=""
            />
          </span>
        </div>
        <div v-else></div>
        <!-- Form -->
        <!-- 
      <form class="flex flex-row flex-wrap items-center lg:ml-auto mr-3">
          <div class="relative flex w-full flex-wrap items-stretch">
          <span
            class="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3"
          >
            <i class="fas fa-search"></i>
          </span>
          <input
            type="text"
            placeholder="Search here..."
            class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:ring w-full pl-10"
          />
        </div> 
      </form>  -->
        <!-- User -->
        <ul class="gap-x-4 list-none items-center flex">
          <notification-dropdown />
          <user-dropdown />
        </ul>
      </div>
    </nav>
    <!-- End Navbar -->

    <div
      v-if="showKycBanner && showThisBanner"
      class="cursor-pointer w-full py-4 px-12 bg-lightBorder flex items-center justify-between"
    >
      <div
        @click="
          $router.push({
            name: 'Profile',
            query: { from: 'dashboard' },
          })
        "
        class="flex gap-2 items-center"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.001 10H13.001V15H11.001V10ZM11 16H13V18H11V16Z"
            fill="white"
          />
          <path
            d="M13.7689 4.20018C13.4209 3.54518 12.7429 3.13818 12.0009 3.13818C11.2589 3.13818 10.5809 3.54518 10.2329 4.20118L2.89493 18.0642C2.73209 18.3686 2.65143 18.7102 2.6609 19.0553C2.67037 19.4005 2.76964 19.7371 2.94893 20.0322C3.12562 20.3286 3.37657 20.5737 3.67697 20.7435C3.97738 20.9133 4.31687 21.0017 4.66193 21.0002H19.3399C20.0479 21.0002 20.6889 20.6382 21.0539 20.0322C21.2329 19.737 21.332 19.4004 21.3415 19.0553C21.351 18.7103 21.2705 18.3687 21.1079 18.0642L13.7689 4.20018ZM4.66193 19.0002L12.0009 5.13718L19.3449 19.0002H4.66193Z"
            fill="white"
          />
        </svg>
        <h1 class="font-medium text-sm text-white">
          Kindly verify your account by clicking here
        </h1>
      </div>

      <div @click="showThisBanner = false" class="justify-end self-end">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.7118 8.28983C15.6188 8.19611 15.5082 8.12171 15.3864 8.07094C15.2645 8.02017 15.1338 7.99404 15.0018 7.99404C14.8698 7.99404 14.7391 8.02017 14.6172 8.07094C14.4954 8.12171 14.3848 8.19611 14.2918 8.28983L12.0018 10.5898L9.71179 8.28983C9.52348 8.10153 9.26809 7.99574 9.00179 7.99574C8.73549 7.99574 8.48009 8.10153 8.29179 8.28983C8.10348 8.47814 7.9977 8.73353 7.9977 8.99984C7.9977 9.26614 8.10348 9.52153 8.29179 9.70984L10.5918 11.9998L8.29179 14.2898C8.19806 14.3828 8.12367 14.4934 8.0729 14.6153C8.02213 14.7371 7.99599 14.8678 7.99599 14.9998C7.99599 15.1318 8.02213 15.2626 8.0729 15.3844C8.12367 15.5063 8.19806 15.6169 8.29179 15.7098C8.38475 15.8036 8.49535 15.878 8.61721 15.9287C8.73907 15.9795 8.86978 16.0056 9.00179 16.0056C9.1338 16.0056 9.26451 15.9795 9.38636 15.9287C9.50822 15.878 9.61882 15.8036 9.71179 15.7098L12.0018 13.4098L14.2918 15.7098C14.3848 15.8036 14.4954 15.878 14.6172 15.9287C14.7391 15.9795 14.8698 16.0056 15.0018 16.0056C15.1338 16.0056 15.2645 15.9795 15.3864 15.9287C15.5082 15.878 15.6188 15.8036 15.7118 15.7098C15.8055 15.6169 15.8799 15.5063 15.9307 15.3844C15.9814 15.2626 16.0076 15.1318 16.0076 14.9998C16.0076 14.8678 15.9814 14.7371 15.9307 14.6153C15.8799 14.4934 15.8055 14.3828 15.7118 14.2898L13.4118 11.9998L15.7118 9.70984C15.8055 9.61687 15.8799 9.50627 15.9307 9.38441C15.9814 9.26255 16.0076 9.13185 16.0076 8.99984C16.0076 8.86782 15.9814 8.73712 15.9307 8.61526C15.8799 8.4934 15.8055 8.3828 15.7118 8.28983ZM19.0718 4.92984C18.1493 3.97473 17.0459 3.21291 15.8258 2.68882C14.6058 2.16473 13.2936 1.88887 11.9658 1.87733C10.638 1.86579 9.32121 2.11881 8.09225 2.62162C6.86328 3.12443 5.74677 3.86696 4.80784 4.80589C3.86891 5.74481 3.12638 6.86133 2.62357 8.09029C2.12076 9.31926 1.86775 10.6361 1.87928 11.9638C1.89082 13.2916 2.16668 14.6038 2.69077 15.8239C3.21486 17.0439 3.97669 18.1474 4.93179 19.0698C5.85426 20.0249 6.9577 20.7868 8.17774 21.3109C9.39778 21.8349 10.71 22.1108 12.0378 22.1223C13.3656 22.1339 14.6824 21.8809 15.9113 21.3781C17.1403 20.8752 18.2568 20.1327 19.1957 19.1938C20.1347 18.2549 20.8772 17.1383 21.38 15.9094C21.8828 14.6804 22.1358 13.3636 22.1243 12.0358C22.1128 10.708 21.8369 9.39583 21.3128 8.17579C20.7887 6.95575 20.0269 5.8523 19.0718 4.92984ZM17.6618 17.6598C16.3538 18.9692 14.6323 19.7847 12.7906 19.9671C10.9488 20.1496 9.10079 19.6879 7.56131 18.6606C6.02183 17.6333 4.88615 16.104 4.34776 14.3333C3.80938 12.5626 3.90159 10.66 4.6087 8.94962C5.31581 7.23926 6.59406 5.82698 8.22568 4.9534C9.8573 4.07981 11.7413 3.79897 13.5568 4.15871C15.3723 4.51845 17.0068 5.49653 18.182 6.9263C19.3572 8.35607 20.0003 10.1491 20.0018 11.9998C20.0054 13.0511 19.8004 14.0927 19.3987 15.0642C18.9971 16.0358 18.4067 16.918 17.6618 17.6598Z"
            fill="white"
          />
        </svg>
      </div>
    </div>
  </main>
</template>

<script setup>
import UserDropdown from "@/components/Dropdowns/UserDropdown.vue";
import NotificationDropdown from "@/components/Dropdowns/NotificationDropdown.vue";
import { storeToRefs, mapWritableState } from "pinia";
import { useDataStore } from "@/stores/data.js";
import { onBeforeRouteLeave, onBeforeRouteUpdate, useRoute } from "vue-router";

import { helperFunctions } from "@/composable/helperFunctions";
import { useToast } from "vue-toastification";
import { computed, onMounted, ref } from "@vue/runtime-core";

import dummyLogo from "@/assets/img/c-logo.png";

const route = useRoute();
const store = useDataStore();
const { query, mutate } = store;
const toast = useToast();

const { log } = helperFunctions;

const accountType = window.localStorage.getItem("accountType");
const companyData = computed(() => store.getCompanyDetails);
const companyAdmin = computed(() => store.getCompanyAdmin);
const kycInfo = computed(() =>
  store.getKyc && store.getKyc.data ? store.getKyc.data : {}
);
const showThisBanner = ref(false);
const showKycBanner = computed(() => {
  if (accountType && accountType !== "COMPANYADMIN") {
    return false;
  }
  if (companyData.value && companyData.value.bvnVerified) {
    return false;
  }
  if (route.path != "/admin/dashboard" && route.path != "/settings/profile") {
    return false;
  }

  if (kycInfo.value.personalInformation) {
    showThisBanner.value = true;
    return false;
  }
  if (
    kycInfo.value.personalInformation &&
    kycInfo.value.personalInformation.status
  ) {
    showThisBanner.value = true;
    return false;
  }
  if (
    (kycInfo.value.personalInformation &&
      kycInfo.value.personalInformation.status.toLowerCase() == "verified") ||
    (kycInfo.value.personalInformation &&
      kycInfo.value.personalInformation.status.toLowerCase() == "pending")
  ) {
    showThisBanner.value = true;
    return false;
  }
  return true;
});

const getAvatar = (comp) => {
  let name = "",
    color;
  // Get color
  const colors = [
    "#D32F2F",
    "#189F00",
    "#0A244F",
    "#E4572E",
    "#E0A409",
    "#184EA8",
    "#F39C36",
    "#4f46e5",
  ];

  log(companyData.value);

  const randomNumber = Math.floor(Math.random() * 5);
  color = colors[randomNumber + 1];

  comp
    ? (name = `${
        comp &&
        comp.company &&
        comp.company.companyName &&
        comp.company.companyName.charAt(0)
      }${
        comp &&
        comp.company &&
        comp.company.companyName &&
        comp.company.companyName.charAt(0)
      }`)
    : "";

  return {
    color,
    name,
  };
};

async function queryCompany() {
  try {
    await query({
      endpoint: "FetchCompaniesByAdminId",
      service: "SETTINGS",
      storeKey: "companyDetails",
    });
  } catch (e) {
    toast.error(e.message);
    console.log(e);
  }
}
const fetchCompanyAdminDetails = async () => {
  try {
    await query({
      endpoint: "FetchCompanyAdmin",
      service: "SETTINGS",
      storeKey: "companyAdmin",
    });
  } catch (e) {
    toast.error(e.message);
    console.log(e);
  }

  // log(adminDetails);
};
const queryKyc = async () => {
  try {
    await query({
      endpoint: "GetKycInformation",
      payload: {},
      service: "SETTINGS",
      storeKey: "listKyc",
    });
  } catch (err) {
    console.log(err);
  }
};

onMounted(async () => {
  await queryKyc();
  await queryCompany();
  await fetchCompanyAdminDetails();
});

// onBeforeRouteLeave(() => {
//   showThisBanner.value = true;
// });
</script>

<style scoped>
.shadow-box {
  box-shadow: 0px 4px 25px rgba(0, 0, 0, 0.05);
}
</style>
